export default function initSlider(targetEl, settings) {
  let $this = $(targetEl);
  $this.not('.slick-initialized').slick(settings)
}



// WEBPACK FOOTER //
// ./app/javascript/utils/slider.js